import { BrowserRouter, useRoutes } from 'react-router-dom';
import Home from './components/Home';
import About from './components/AboutMe';
import Contact from './components/Contact';
import SpecializedCleaning from './components/SpecializedCleaning';
import PrivacyPolicy from './components/PrivacyPolicy';
import CommercialCleaning from './components/CommercialCleaning';
import ResidentialCleaning from './components/ResidentialCleaning';
import Transport from './components/Transport';
import Terms from './components/Terms';
import { ThemeProvider } from 'styled-components';
import GlobalStyles from './components/Global';

import './App.css';

const theme = {
  color: {
    lime: 'hsl(61, 70%, 52%)',
    yellow: ' hsl(50, 100%, 49%) ',
    red: 'hsl(4, 69%, 50%)',
    slate100: 'hsl(202, 86%, 94%)',
    slate300: 'hsl(203, 41%, 72%)',
    slate500: 'hsl(200, 26%, 54%)',
    grey: '#e1e1e1',
    bgBlue: '#f0fbff',
    lightBlue: '#00a6e4',
    blue: 'rgb(21, 72, 154)',
    darkBlue: '#253340',
    green: ' #279e64',
    text: '#253340'
  },
  breakpoints: {
    mobile: '350px',
    tablet: '768px',
    laptop: '1070px',
  },
};

function AppRoutes() {
  return useRoutes([
    { path: '/', element: <Home /> },
    { path: '/about', element: <About /> },
    { path: '/contact', element: <Contact /> },
    { path: '/terms', element: <Terms /> },
    { path: '/specialized-cleaning', element: <SpecializedCleaning /> },
    { path: '/privacy', element: <PrivacyPolicy /> },
    { path: '/commercial-cleaning', element: <CommercialCleaning /> },
    { path: '/residential-cleaning', element: <ResidentialCleaning /> },
    { path: '/facilities-management', element: <ResidentialCleaning /> },
    { path: '/transport-and-logistics', element: <Transport /> },
  ]);
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <BrowserRouter>
        <>
          <AppRoutes />
        </>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
